import React from 'react'
//import _ from 'lodash'
import {statusColour} from './BudgetStatus'
import {Motion, spring} from 'react-motion';


const BudgetChart = ({dimensions, values}) => {

    const padding = 0.1

    //let fractionUsed = 0
    //_.keys(colours).filter(k => (k !== 'remaining')).forEach(k => fractionUsed += values[k])
    const colour = statusColour(values.remaining)
    //console.log('colo', values, colour, Math.round(padding * dimensions.width), Math.round((1 - values.remaining) * dimensions.width * (1 - 2 * padding)))


    return <div>
        {/*console.log('cc',colours, dimensions, values)*/}

        <div>


            <Motion defaultStyle={{x: 0}} style={{x: spring(dimensions.width, {stiffness:100, damping:25})}}>
                {value =>

                <svg style={{width: `${Math.round(dimensions.width)}px`, height: `100px`}}>

                    {/*_.keys(colours).map(k => (k !== 'remaining' || values[k] >= 0) && <rect
                        key={k}
                        x={`${incx(Math.round(values[k] * dimensions.width * 0.8))}px`}
                        width={`${Math.round(values[k] * dimensions.width * 0.8)}px`}
                        height={`100%`}
                        fill={colours[k].c}
                    />)*/}

                        <rect
                            x={`${Math.round(padding * dimensions.width)}px`}
                            width={`${Math.round((1 - values.remaining) * value.x * (1 - 2 * padding))}px`}
                            height={`100%`}
                            fill={colour.c}
                        />
                        <line x1={dimensions.width * padding      } x2={dimensions.width * padding      } y1="0" y2="100" stroke="#000" strokeWidth="1" strokeDasharray="5, 3"/>
                        <line x1={dimensions.width * padding      } x2={dimensions.width * (1 - padding)} y1="0" y2="0" stroke="#000" strokeWidth="1" strokeDasharray="5, 3"/>
                        <line x1={dimensions.width * padding      } x2={dimensions.width * (1 - padding)} y1="100" y2="100" stroke="#000" strokeWidth="1" strokeDasharray="5, 3"/>
                        <line x1={dimensions.width * (1 - padding)} x2={dimensions.width * (1 - padding)} y1="0" y2="100" stroke="#000" strokeWidth="1" strokeDasharray="5, 3"/>
                </svg>
                }
            </Motion>
        </div>

        {/*<div style={{marginLeft: '10%', width: `${Math.round(dimensions.width * 0.8)}px`, height: `100px`}}>
            <div style={{width: `100%`, height: `100%`}}>
                {_.keys(colours).map(k => {

                    console.log('w', Math.round(dimensions.width * 0.8), Math.round(values[k] * dimensions.width * 0.8))

                    return <div
                        key={k}
                        style={{backgroundColor: colours[k].c,
                            width: `${Math.round(values[k] * dimensions.width * 0.8)}%`,
                            height: `100%`,
                            display: `inline-block`
                        }}
                    />})}
            </div>
        </div>*/}
    </div>
}

export default BudgetChart


// WEBPACK FOOTER //
// ./src/components/budget/BudgetChart.jsx